<div class="watchlist-page">
  <ng-container *ngIf="hasUserCreatedWatchlists && isWatchlistExist">
    <div class="header">
      <div class="watchlist-rename">
        <span>{{ watchlistName }}</span>
      </div>

      <div class="quick-actions">
        <div
          class="action-btn toggle-icon-onhover color-primary"
          nz-popover
          nzPopoverTitle="Edit Alert"
          [(nzPopoverVisible)]="visibleAlerts"
          nzPopoverTrigger="click"
          nzPopoverPlacement="bottomRight"
          nzPopoverOverlayClassName="alerts-popover-overlay"
          [nzPopoverContent]="alertsTemplate"
        >
          <div class="icon-container">
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="falBell"
            ></va-icon>
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="fasBell"
            ></va-icon>
          </div>
          <span>Alert</span>
        </div>

        <!-- Share Watchlist button -->
        <div
          *ngIf="watchlistId > -1"
          (click)="showShareWatchlistModal()"
          [ngClass]="
            !isOwned
              ? 'action-btn toggle-icon-onhover color-primary disable'
              : 'action-btn toggle-icon-onhover color-primary'
          "
        >
          <div class="icon-container">
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="falShare"
            ></va-icon>
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="fasShare"
            ></va-icon>
          </div>
          <span>Share</span>
        </div>

        <!-- Add export button here modal -->
        <div
          *ngIf="!isExcelLoading"
          class="action-btn toggle-icon-onhover color-primary"
          (click)="exportWatchlist()"
        >
          <div class="icon-container">
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="falExcel"
            ></va-icon>
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="fasExcel"
            ></va-icon>
          </div>
          <span>Export</span>
        </div>
        <div *ngIf="isExcelLoading" class="action-btn">
          <div class="loader-container">
            <ng-template #indicatorTemplate>
              <va-icon 
                size="small"
                isFontAwesome="true"
                class="icon"
                [name]="faSpinner"
                [spin]="true"
                [styles]="{
                  'font-size': '15px',
                  color: '#fff',
                  'font-weight': 'bold'
                }"
              ></va-icon>
            </ng-template>
            <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
          </div>
          <span>Export</span>
        </div>
        <!-- Delete Watchlist button -->
        <div
          *ngIf="watchlistId > -1"
          class="action-btn toggle-icon-onhover color-red"
          (click)="showDeleteAlertModal()"
        >
          <div class="icon-container">
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="falTrash"
            ></va-icon>
            <va-icon
              isFontAwesome="true"
              class="icon"
              [name]="fasTrash"
            ></va-icon>
          </div>
          <span>Delete</span>
        </div>
      </div>
    </div>

    <div class="secondary-action-header">
      <button
        *ngIf="isOwned"
        class="edit-company-btn"
        nz-button
        nzType="primary"
        nzSize="small"
        [disabled]="watchlistId === -1 || !isOwned"
        (click)="openSearchAndAddWatchlistModal()"
      >
        Edit Watchlist
      </button>
      <button
        *ngIf="!isOwned"
        class="edit-company-btn"
        nz-button
        nzType="primary"
        nzSize="small"
        nz-tooltip
        nzTooltipPlacement="right"
        nzTooltipTitle="Save as my watchlist"
        (click)="openAndSaveWatchlistModal()"
      >
        Save Watchlist
      </button>

      <div class="toggle-with-label">
        <span class="label">Show Filter</span
        ><nz-switch nzSize="small" [(ngModel)]="showGridFilter"></nz-switch>
      </div>
    </div>
    <div class="table-container">
      <app-watchlist-grid
        [listOfData]="watchlistGridData"
        [lastTransactionInfo]="lastTransactionInfo"
        [watchlistId]="watchlistId"
        [showGridFilter]="showGridFilter"
        (selectedTickers)="selectedTickersFromGrid($event)"
        [isGridLoading]="isGridLoading"
      ></app-watchlist-grid>
    </div>
  </ng-container>

  <!-- if hasUserCreatedWatchlists is defined and false -->
  <ng-container
    *ngIf="
      hasUserCreatedWatchlists !== null && hasUserCreatedWatchlists === false
    "
  >
    <p class="cta-watchlist-create">
      Click here
      <button (click)="showWatchlistModal()" nz-button nzType="primary">
        Create New Watchlist
      </button>
      to create your first one!
    </p>
  </ng-container>

  <ng-container *ngIf="!isWatchlistExist">
    <div class="error-container">
      <div class="error-msg">
        <va-icon
          isFontAwesome="true"
          [name]="faExclamationTriangle"
          class="info-icon"
        ></va-icon>
        <span class="error-text">No data found for selected watchlist.</span>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #alertsTemplate>
  <app-alerts-popover
    [params]="alertsParams"
    (onSet)="closeAlertsPopover($event)"
  ></app-alerts-popover>
</ng-template>

<app-watchlist-modal
  [(selectedWatchlistId)]="watchlistId"
  [(selectedWatchlistName)]="watchlistName"
  [(existingTickers)]="tickersList"
  [modalTitle]="'Edit Watchlist'"
  [(visible)]="isVisibleSearchAndAddWatchlistModal"
  (onClose)="closeSearchAndAddWatchlistModal()"
  (updatedWatchlistData)="reloadGridData()"
></app-watchlist-modal>

<app-watchlist-modal
  [visible]="isVisibleWatchlistModal"
  (onClose)="onCloseWatchlistModal()"
></app-watchlist-modal>

<app-watchlist-modal
  [(selectedWatchlistId)]="watchlistId"
  [(selectedWatchlistName)]="watchlistName"
  [(existingTickers)]="tickersList"
  [modalTitle]="'Save Watchlist'"
  [receivedWatchlist]="true"
  [(visible)]="isVisibleSaveWatchlistModal"
  (onClose)="onCloseWatchlistModal()"
></app-watchlist-modal>

<app-share-watchlist-modal
  *ngIf="watchlistId"
  [visible]="isVisibleShareWLModal"
  (onClose)="onCloseShareWatchlistModal()"
  [watchlistId]="watchlistId"
>
</app-share-watchlist-modal>
